import { render, staticRenderFns } from "./MobileMenuEntry.vue?vue&type=template&id=4a625a7c&"
import script from "./MobileMenuEntry.vue?vue&type=script&lang=ts&"
export * from "./MobileMenuEntry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports